var _path, _path2, _line, _line2, _line3, _line4, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 90,
    viewBox: "0 0 108 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6 19.7267H72.8853",
    stroke: "#001F3D",
    strokeWidth: 0.768571,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1372 21.1357V24.4662",
    stroke: "#001F3D",
    strokeWidth: 0.768571,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.9036,
    y1: 38.1725,
    x2: 86.9777,
    y2: 38.1725,
    stroke: "#F0FAEF",
    strokeWidth: 8.71048,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.7053,
    y1: 48.6763,
    x2: 78.7795,
    y2: 48.6763,
    stroke: "#F0FAEF",
    strokeWidth: 8.71048,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 28.052,
    y1: 53.5438,
    x2: 94.6633,
    y2: 53.5438,
    stroke: "#F0FAEF",
    strokeWidth: 7.17333,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 28.052,
    y1: 42.2715,
    x2: 93.1262,
    y2: 42.2715,
    stroke: "#F0FAEF",
    strokeWidth: 8.71048,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.2327,
    cy: 44.321,
    r: 21.0076,
    fill: "#CCEEC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9235 44.6486C48.3162 44.2559 48.953 44.2559 49.3457 44.6486L53.4082 48.7111C53.961 49.2639 54.8547 49.2631 55.4041 48.7136L63.5316 40.5861C63.9244 40.1934 64.5611 40.1934 64.9539 40.5861C65.3466 40.9788 65.3466 41.6156 64.9539 42.0084L56.8264 50.1359C55.4894 51.4728 53.3223 51.4697 51.986 50.1333L47.9235 46.0708C47.5307 45.6781 47.5307 45.0413 47.9235 44.6486Z",
    fill: "#32872C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1372 14.6029V18.4458",
    stroke: "#001F3D",
    strokeWidth: 0.768571,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.418 19.7267H82.7484",
    stroke: "#001F3D",
    strokeWidth: 0.768571,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4569 71.7334H31.895",
    stroke: "#001F3D",
    strokeWidth: 0.768571,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7378 72.7582V75.0639",
    stroke: "#001F3D",
    strokeWidth: 0.768571,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7378 67.8905V70.7086",
    stroke: "#001F3D",
    strokeWidth: 0.768571,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5063 71.7334H38.8121",
    stroke: "#001F3D",
    strokeWidth: 0.768571,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportCompleted);
export default __webpack_public_path__ + "static/media/transport-completed.18c0cc25469cb4b9b023e0a475db59bd.svg";
export { ForwardRef as ReactComponent };